import { ResetFormButton, SubmitFormButton } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { toSentenceCase } from 'shared/utils/to_sentence_case'

import { settingsModalFooterActionsCss } from './styles'

/** Shared Save/Cancel actions rendered in the settings modal footer host. */
export const SettingsModalFooterActions = ({ onSave, onCancel }) => (
  <div className={settingsModalFooterActionsCss}>
    <ResetFormButton type="button" onClick={onCancel}>
      {toSentenceCase(I18n.t('publisher.action.cancel'))}
    </ResetFormButton>
    <SubmitFormButton type="button" onClick={onSave}>
      {toSentenceCase(I18n.t('publisher.action.save_changes'))}
    </SubmitFormButton>
  </div>
)
